<template>
  <div class="cansaizhuce">
     <div class="denglulogo">
       <img src="../assets/head-logo.png" alt="">
     </div>
    <!-- 关闭返回首页按钮 -->
    <router-link to="/">
      <div class="cno"></div>
    </router-link>

    <div class="cansaizhuce-cont">
      <!-- 标题 -->
      <div class="cansaizhuce-title">
        <p>欢迎注册全国铁道供电微课大赛！</p>
      </div>
      <!-- 注册列表 -->
      <div class="cansaizhuce-cont-list">
        <!-- 上半部分列表 -->
        <div class="cs-cont-list-top">
          <div class="cs-cont-list-left-sel">
            <span><i class="dimi">*</i> 注册身份</span>
            <div class="kongssc"></div>
            <el-select
              id="cansaizhuce-sel"
              @change="cstype()"
              value-key="weid"
              v-model="Cansaivalue"
              placeholder="请选择"
            >
              <el-option
                v-for="item in cansaioption"
                :key="item.weid"
                :label="item.label"
                :value="item"
              >
              </el-option>
            </el-select>
          </div>
          <!-- 参赛单位 -->
          <div class="cs-cont-list-right-sel">
            <span><i class="dimi">*</i> 参赛单位</span>
            <div class="kongssc"></div>
            <el-select
              id="cansaizhuce-sel-company"
              value-key="id"
              v-model="companyvalue"
              placeholder="请选择参赛单位"
            >
              <el-option
                v-for="item in companyoption"
                :key="item.id"
                :label="item.name"
                :value="item"
              >
              </el-option>
            </el-select>
          </div>
          <!-- 账号信息填写-->
          <div class="cs-inp">
            <div class="cs-inp-user cs-inp-w">
            <span> <i class="dimi">*</i> 用户名</span>
              <el-input placeholder="请输入用户名" v-model="csuser"></el-input>
            </div>
            <div class="cs-inp-pswoder cs-inp-w">
              <span><i class="dimi">*</i> 账号密码</span>
              <el-input
                placeholder="请输入账号密码"
                v-model="csword"
                show-password
              ></el-input>
            </div>
            <div class="cs-inp-emil cs-inp-w">
              <span><i class="dimi">*</i> 邮箱地址</span>
              <el-input placeholder="请输入邮箱地址" v-model="csemil"></el-input>
            </div>

            <div class="cs-inp-name cs-inp-w">
              <span><i class="dimi">*</i> 个人姓名</span>
              <el-input placeholder="请输入个人姓名" v-model="csname"></el-input>
            </div>
            <div class="cs-inp-zhicheng cs-inp-w">
              <span><i class="dimi">*</i> 个人职称</span>
              <el-input placeholder="请输入个人职称" v-model="cszhicheng"></el-input>
            </div>
            <div class="cs-inp-phone cs-inp-w">
              <span><i class="dimi">*</i> 手机号</span>
              <el-input placeholder="请输入手机号" v-model="csphone"></el-input>
            </div>
          </div>
          <!-- 个人简介和工作证件 -->
          <div class="cs-text">
            <!-- 个人简介 -->
            <div class="cs-text-jianjie">
              <span>个人简介</span> <br />
              <el-input
                type="textarea"
                placeholder="请输入内容"
                v-model="threetextarea"
                maxlength="80"
                show-word-limit
                :rows="7"
                :cols="37"
                resize="none"
              >
              </el-input>
            </div>
            <!-- 工作证上传 -->
            <div class="cs-text-zheng">
              <span><i class="dimi">*</i> 工作证件</span>
              <div class="cs-text-zheng-uplode">
 <el-upload
  class="avatar-uploader"
  :action="imgposturl"
  :show-file-list="false"
  :on-success="handleAvatarSuccess"
   :before-upload="beforeAvatarUpload"

  accept=".jpg,.jpeg,.png"
  >
   <!-- :before-upload="beforeAvatarUpload"上传前钩子函数 -->
  <img v-if="imgurltwo" :src="imgurltwo" class="avatar">
  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
</el-upload>
   <p  v-if="upptxt" class="upzheng-ps">请上传“工作证或者教师证”</p>
              </div>
            </div>
          </div>
        </div>
        <!-- 注册登录按钮 -->
        <div class="cs-btn-cs">
          <button @click="caisaipost()" class="cs-btn-cs-zc" type="button">立即注册</button>
          <router-link to="/denglu">
          <button class="cs-btn-cs-dl" type="button">参赛用户登录</button>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import cansaizhuce from "../css/CansaiZhuce.css";
import axios from "axios";
export default {
  data() {
    return {
      cansaioption: [
        {
          weid: 2,
          label: "参赛教师",
        },
         {
          weid: 1,
          label: "普通用户",
        },
      ],
      companyoption: [],
      Cansaivalue: "",
      companyvalue: "",
      csuser: "", //账户ID
      csword: "",  //密码
      csemil: "",   //邮箱
      csname: "",  //姓名
      cszhicheng: "", //职称
      csphone: "",  //手机号
      threetextarea: "", //个人简介
      imgurltwo:'',//证件照地址
      imgposturl:this.$apiUrl+'/index.php/index/upload',
      imageUrl:'',
      upptxt:true

    };
  },
  created(){
    this.Cansaivalue = this.cansaioption[0];

  },
  methods:{
    cstype(){
     if (this.Cansaivalue.weid == 1) {
       this.$router.push({path:'/zhuce'})
     }
    },

    //   // 图片上传
    handleAvatarSuccess(res, file) {
       this.imgurltwo = URL.createObjectURL(file.raw);
       this.imageUrl = res.msg;
      },

      beforeAvatarUpload(file) {
       this.upptxt = false;
        const isimg = file.type === 'image/jpeg' ||
        file.type === "image/JPG" ||
        file.type === "image/png" ||
        file.type === "image/PNG" ||
        file.type === "image/jpg" ||
        file.type === "image/gif";
        // const isPNG = file.type === 'image/png';
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isimg) {
          this.$message.error('请上传JPG或PNG 格式图片!');
        }

        if (!isLt2M) {
          this.$message.error('上传图片大小不能超过 2MB!');
        }
        return isimg &&  isLt2M;
        // isJPG &&
      },
    caisaipost(){
      let username = this.csuser;
      let password = this.csword;
      let type = this.Cansaivalue.weid;
      let email = this.csemil;
      let name = this.csname;
      let title = this.cszhicheng;
      let phone = this.csphone;
      let message = this.threetextarea;
      let image = this.imageUrl;
      //  console.log(type,'默认的')

      let work_unit_id = this.companyvalue.id;
      let work_unit = this.companyvalue.name;

      // 正则验证
    var patrnhz =  /^[\u4e00-\u9fa5]{1,10}$/; //名字验证
    var patrname = /^[\d\w]{6,16}$/ //账号
    var patrnword=/^[a-zA-Z\d,\.，。]{6,16}$/; //密码
    var patrnphone = /^[\d]{11}$/;//手机号
    var patrnemail =/^(([0-9a-zA-Z]+)|([0-9a-zA-Z]+[_.0-9a-zA-Z-]*[0-9a-zA-Z]+))@([a-zA-Z0-9-]+[.])+([a-zA-Z]{2}|net|NET|com|COM|gov|GOV|mil|MIL|org|ORG|edu|EDU|int|INT)$/;
    var patrnzhic =  /^[\u4e00-\u9fa5]{1,}$/;
    if (!patrnhz.exec(name)) {
  this.$message({
    message:'姓名输入错误！请输入汉字',
    offset:100
  });
  return false
}else if (!patrnword.exec(password)) {
   this.$message({
     message:'账号密码输入错误，请输入6-16位数字，字母！！！',
     offset:100
   });
  return false
}else if(!patrname.exec(username)) {
   this.$message({
     message:'用户名输入错误！请输入6-16位的数字，字母！',
     offset:100
   });
  return false
}else if (!patrnphone.exec(phone)) {
   this.$message({
     message:'手机号输入错误！请输入正确的手机号',
     offset:100
   })
  return false
}else if (!patrnemail.exec(email)) {
   this.$message({
     message:'个人邮箱输入错误！请输入正确的邮箱地址',
     offset:100
   })
  return false
}else if (!patrnzhic.exec(title)) {
   this.$message({
     message:'个人职称输入错误！请输入正确职称',
     offset:100
   })
  return false
}
      // 发送数据

      let postdata = this.$qs.stringify({
        username:username,
        password:password,
        type:type,
        email:email,
        name:name,
        title:title,
        phone:phone,
        message:message,
        work_unit_id:work_unit_id,
        work_unit:work_unit,
        image:image

      });

      axios({
  method: 'post',
  url: this.$apiUrl+'/index.php/index/register',

  data:postdata

}).then(res=>{

   if (res.data.code==1) {
     this.$message({
       message:res.data.msg,
       offset:100
     })

this.$router.push({path:'/denglu'});



   } else if(res.data.code==0){
     this.$message({
       message:res.data.msg,
       offset:100
     })
   }
}).catch(error=>{
  console.log(error);
})
    },
    // 请求参赛单位
      onLoad(){
      axios({
  method:'get',
  url:this.$apiUrl+'/index.php/index/school',
  // timeout: 1000,

}).then(res=> {
this.companyoption = res.data.data;

}).catch(error =>{
    console.log(error);
})
},

  },
  mounted(){
    this.onLoad();
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/CansaiZhuce.vue